import React from 'react';
import { Tooltip, Icon } from 'antd';
import { FormattedHTMLMessage } from 'react-intl';
import messages from 'containers/Quotation/messages';

export const AlertIcon = ({size}) => {
  return (
      <Icon
        type='exclamation-circle'
        style={{
          color: '#ff4a50',
          verticalAlign: '2px',
          marginLeft: '5px',
          fontSize: size || null
        }}
      />
  );
};

const ExpiredTooltip = ({children, showIcon, size}) => {
  return (
    <Tooltip title={<FormattedHTMLMessage {...messages.expiredOffer} />}>
      {children}
      {showIcon &&
        <AlertIcon size={size} />
      }
    </Tooltip>
  );
};

export default ExpiredTooltip;
